import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Link from "shared/components/Link";

import "./BlankState.scss";

const BlankState = (props) => {
	let description;
	const containerParams = {
		className: `blank-state-wrapper ${props.className}`,
	};

	if (props.description) {
		if (props.description.constructor === Array) {
			description = props.description.map((line) => {
				return <p key={line} className="blank-state-description">{line}</p>;
			});
		} else {
			description = <p className="blank-state-description">{props.description}</p>;
		}
	}

	if (props.id) {
		containerParams.id = props.id;
	}

	return (
		<div {...containerParams}>
			<div className={classnames("blank-state", {
				"blank-state--noButtons": !props.buttons,
				[`${props.parent}-blank`]: props.parent,
			})}>
				<h2 className="blank-state-title">{props.title}</h2>
				{description}
				{props.buttons &&
					<div className="blank-state-buttons">{props.buttons}</div>
				}
				{props.ctaLink && props.ctaText &&
					<div className="blank-state-buttons">
						<Link className="flatbutton" to={props.ctaLink} noSpa={props.ctaNoSpa}>
							{props.ctaText}
						</Link>
					</div>
				}
			</div>
		</div>
	);
};

BlankState.propTypes = {
	title: PropTypes.node.isRequired,
	description: PropTypes.node,
	id: PropTypes.string,
	parent: PropTypes.string,
	buttons: PropTypes.node,
	ctaLink: PropTypes.string,
	ctaText: PropTypes.string,
	ctaNoSpa: PropTypes.bool,
	className: PropTypes.string,
};

BlankState.defaultProps = {
	description: null,
	id: null,
	parent: null,
	buttons: null,
	ctaLink: null,
	ctaText: null,
	ctaNoSpa: true,
	className: "",
};

export default BlankState;



// WEBPACK FOOTER //
// ./src/shared/components/BlankState.jsx